/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//コレクションページ サイドバーリンク 子リンク開閉
$(function () {
  $(".childlink__arrow").click(function () {
    $(this).toggleClass("active");
    $(this).next(".ChildLinklist").slideToggle();
  });
});

//SP ページ内ボタン 表示・非表示切り替え
//カートボタンが画面からいなくなったら、カートへ遷移ボタンを表示する
$(document).ready(function () {
  if (window.matchMedia("(max-width: 640px)").matches) {
    $("#modalOpen").hide();
    var top = $("#Product__AddToCartButton").offset().top;
    if ($(window).height() < top) {
      //最初に#btnBlockが見えてない場合
      $("#modalOpen").show();
    }
  }
});

$(window).scroll(function () {
  if (window.matchMedia("(max-width: 640px)").matches) {
    var top = $("#Product__AddToCartButton").offset().top;
    if ($(window).height() > top) {
      // 最初に#btnBlockが見えている場合
      if ($(window).scrollTop() > top) {
        $("#modalOpen").fadeIn();
      } else {
        $("#modalOpen").fadeOut();
      }
    } else {
      // 最初に#btnBlockが見えていない場合
      if (
        $(window).scrollTop() + $(window).height() > top &&
        $(window).scrollTop() < top
      ) {
        $("#modalOpen").fadeOut();
      } else {
        $("#modalOpen").fadeIn();
      }
    }
  }
});

// 商品詳細タブをデフォルトで開いた状態に(PCのみ)
$(function () {
  if (window.matchMedia("(min-width:1008px)").matches) {
    $(".Product__Tabs .Collapsible:first-child .Collapsible__Button").attr(
      "aria-expanded",
      true
    );
    $(".Product__Tabs .Collapsible:first-child").css("overflow", "visible");
    $(".Product__Tabs .Collapsible:first-child .Collapsible__Inner").css({
      overflow: "visible",
      height: "auto",
    });
  }
});

//コレクションページ カートボタンアコーディオン
$(function () {
    //クリックで動く;
    $(document).on("click", ".nav-open", function () {
      $(this).toggleClass("active");
      $(this).children(".colllection__cartButton").slideToggle();
    });

    $(document).on("click", ".colllection__cartButton", function (event) {
        event.stopPropagation();
    });
});

//同クラスの要素の高さを合わせる
$(function () {
  $(".ProductItem .ProductItem__Info").matchHeight(); //.matchHeight の部分は任意のクラス名
});

//商品一覧 カートボタン 数量変更ボタン
(() => {
  const downbutton = document.getElementsByClassName("Quantity_sub");
  const upbutton = document.getElementsByClassName("Quantity_add");
  const text = document.getElementsByClassName("Quantity_value");

  //ボタンが押されたらカウント減
  const dowmButtonArray = Array.from(downbutton);
  dowmButtonArray.forEach((subButton, index) => {
    subButton.addEventListener("click", (event) => {
      //0以下にはならないようにする
      if (text[index].value >= 1) {
        text[index].value--;
      }
    });
  });

  //ボタンが押されたらカウント増
  const upButtonArray = Array.from(upbutton);
  upButtonArray.forEach((addButton, index) => {
    addButton.addEventListener("click", (event) => {
      text[index].value++;
    });
  });
})();

//// 商品詳細 モーダルウィンドウ 
const buttonOpen = document.getElementById('modalOpen');
const modal = document.getElementById('easyModal');
const buttonClose = document.getElementsByClassName('modalClose')[0];

// ボタンがクリックされた時
if (buttonOpen){ 
buttonOpen.addEventListener('click', modalOpen);
}
function modalOpen() {
  modal.style.display = 'block';
}
// バツ印がクリックされた時
if (buttonClose){ 
buttonClose.addEventListener('click', modalClose);
}
function modalClose() {
  modal.style.display = 'none';
}
// モーダルコンテンツ以外がクリックされた時
addEventListener('click', outsideClose);
function outsideClose(e) {
  if (e.target == modal) {
    modal.style.display = 'none';
  }
}

//商品詳細 在庫数に応じてテキスト表示 バリエーションごとにだし分け
const option = document.getElementsByClassName("Popover__Value");
const options = Array.from(option);
const productMetaQuantities = document.querySelectorAll(".ProductMeta_quantity");

options.forEach((option, index) => {
  ////バリエーション変更時の処理
  option.addEventListener("click", () => {
    $(".ProductMeta_quantity").css("display", "none");
    if (productMetaQuantities[index]) {
      productMetaQuantities[index].style.display = "block";
    }
  });
});

////ページが読み込まれたときの処理
window.addEventListener("DOMContentLoaded", (event) => {
  options.forEach((option, index) => {
    if (option.classList.contains("is-selected") && productMetaQuantities[index]) {
       productMetaQuantities[index].style.display = "block";
    }
  });
});


////ログイン画面での会員登録非表示
document.addEventListener('DOMContentLoaded', function() {

    var forgotPasswordButton = document.querySelector('.form_help_text');
    var loginLinkButton = document.querySelector('.backto_login_link');
    var registerContainer = document.querySelector('.register_container');

    forgotPasswordButton.addEventListener('click', function() {
        registerContainer.style.display = 'none';
    });

    // loginLinkButtonが存在する場合のみイベントリスナーを追加
    if (loginLinkButton) {
        loginLinkButton.addEventListener('click', function() {
            registerContainer.style.display = 'flex';
        });
    }
});